export default [
  {
    path: '/user',
    component: () => import('@/views/user/userList.vue')
  },
  {
    path: '/user/:userNo',
    component: () => import('@/views/user/userDetail.vue')
  },
  {
    path: '/user/withdraw',
    component: () => import('@/views/user/userWithdrawList.vue')
  },
  {
    path: '/user/withdraw/:userNo',
    component: () => import('@/views/user/userWithdrawDetail.vue')
  }
];
